import { BrandColors } from '../theme';

export const paginatorTokens = {
    root: {
        padding: '0.5rem 1rem',
        gap: '0.25rem',
        borderRadius: '50%',
        background: 'transparent',
        color: BrandColors.surface[500],
    },
    navButton: {
        background: 'transparent',
        hoverBackground: BrandColors.surface[100],
        selectedBackground: BrandColors.primary[500],
        color: BrandColors.surface[500],
        hoverColor: BrandColors.surface[700],
        selectedColor: BrandColors.semantic.textInverse,
        borderRadius: '50%',
    },
};
